import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../store';
import { ItemType } from '../../types';

export const useDisplayingItemMarker = (itemId: string, isOverMouse: boolean) => {
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);

    const [isDisplay, setIsDisplay] = useState<boolean>(false);

    useEffect(() => {
        setIsDisplay(isOverMouse || itemId === currentGantItem?.id);
    }, [currentGantItem, isOverMouse]);

    return isDisplay;
};
